import { ipiCstOptions } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.const';
import { Select, SelectProps } from 'antd';

const TaxeIpiCstSelect: React.FC<SelectProps> = (props) => {
  return (
    <Select
      {...props}
      options={ipiCstOptions?.map((code) => ({
        value: code.value,
        label: code.label,
      }))}
    />
  );
};

export default TaxeIpiCstSelect;
